$(document).on('click', '.quick-add__submit-alt', function(){
	var $data = [];
	var $this = $(this),
	$variantId = $this.closest('.card__content').find('.card-variants-container input:checked').data('variant-id');
	$data.push({
		'quantity': 1,
		'id':$variantId
	});
	$this.closest('.card-wrapper').find('.atc-label').text('Adding...');
	$this.closest('.card-wrapper').find('.quick-add__submit-alt').addClass('disabled');
	const cart_holder = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
	const sections = cart_holder.getSectionsToRender().map((section) => section.id);
	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		dataType: 'json',
		data: {
			items: $data,
			sections,
			sections_url: window.location.pathname + (window.location.search || '')
		},
		success: function (response) {
			$this.closest('.card-wrapper').find('.atc-label').text('Added!');
			setTimeout(function(){
				$this.closest('.card-wrapper').find('.atc-label').text('Add to Cart');
				$this.closest('.card-wrapper').find('.quick-add__submit-alt').removeClass('disabled');
			}, 500);
			if (response.status) {
				alert(response.description || 'An error has occurred.')
				return;
			}

			let cartAddResponse = response;
			if (cart_holder && cart_holder.classList.contains('is-empty')) {
				cart_holder.classList.remove('is-empty');
			}
			cart_holder.renderContents(response);
		},
		error: function (response, a, b) {
			if (response) {
				alert(response?.responseJSON?.description || 'An error has occurred.')
				return;
			}
		}
	});
});

$(document).on('change', '.card-variants-container input', function(){
	var $this = $(this),
	$target = $this.closest('.card-variants-container').find('input:checked'),
	$title = $target.val(),
	$image = $target.data('image'),
	$available = $target.data('available'),
	$price = $target.data('price'),
	$comparePrice = $target.data('compare-price'),
	$btn = $this.closest('.card__content').find('.quick-add__submit-alt');
	if($available == false) {
		$btn.find('.atc-label').text('Sold Out');
		$btn.addClass('disabled');
	} else {
		$btn.find('.atc-label').text('Add to Cart');
		$btn.removeClass('disabled')
	}
	$btn.find('.atc-price').text($price);
	$btn.find('.atc-compare-price').text($comparePrice);
	if($image != '' || $image != ' ') {
		$target.closest('.product__card-alt').find('.card__media img').attr('src', $image).attr('srcset', $image).data('src', $image);
	}
	var $selectedShade = $this.closest('.card__content').find('.selected-shade-option');
	if($selectedShade.length) {
		$selectedShade.text($title);
	}
	var $tag = $this.closest('li').find('span[data-tag-handle="refillable"]');
	if($tag.length) {
		var $originalText = $tag.data('value');
		if($title == 'Refill') {
			$tag.text('Refill Only');
		} else {
			$tag.text($originalText)
		}
	}
});

$(document).on('click', '.show-hidden-options', function(){
	var $this = $(this),
	$target = $this.closest('.card-variants-container').find('.hidden-options');
	$this.hide();
	$target.removeClass('hidden-options');
});

$(document).on('click', '.custom-tab-nav a', function(){
	var $this = $(this),
	$target = $($this.attr('href'));
	if(!$this.hasClass('active-nav')) {
		$this.closest('.custom-tab-nav').find('a').removeClass('active-nav');
		$this.addClass('active-nav');
		$this.closest('.page-width').find('.active-tab-item').removeClass('active-tab-item').hide();
		$target.show().addClass('active-tab-item');
	}
	return false;
});

$(document).on('click', '.faq-nav-content a', function(){
	var $this = $(this),
	$target = $($this.attr('href')),
	$offset = $target.offset().top - $('#shopify-section-announcement-bar').outerHeight() - $('#shopify-section-header').outerHeight();
	$('html, body').animate({
		'scrollTop': $offset
	});
	return false;
});

$(document).on('click', '.tb-shop-btn[data-variant-id]', function(){
	var $data = [];
	var $this = $(this),
	$variantId = $this.data('variant-id');
	$data.push({
		'quantity': 1,
		'id':$variantId
	});
	$this.text('Adding...');
	$this.addClass('disabled');
	const cart_holder = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
	const sections = cart_holder.getSectionsToRender().map((section) => section.id);
	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		dataType: 'json',
		data: {
			items: $data,
			sections,
			sections_url: window.location.pathname + (window.location.search || '')
		},
		success: function (response) {
			$this.text('Added!');
			setTimeout(function(){
				$this.text('Add to Cart');
				$this.removeClass('disabled');
			}, 500);
			if (response.status) {
				alert(response.description || 'An error has occurred.')
				return;
			}

			let cartAddResponse = response;
			if (cart_holder && cart_holder.classList.contains('is-empty')) {
				cart_holder.classList.remove('is-empty');
			}
			cart_holder.renderContents(response);
		},
		error: function (response, a, b) {
			if (response) {
				alert(response?.responseJSON?.description || 'An error has occurred.')
				return;
			}
		}
	});
});

function headerTopOffset() {
	var $bar = $('#shopify-section-announcement-bar');
	var $header = $('#shopify-section-header');

	if ($bar.length > 0) {
		var offset = $bar.offset().top;
		$header.css('--top-offset', offset + 'px');
	}
}

$(document).on('load', function(){
	headerTopOffset();
});

$(window).on('resize', function() {
	headerTopOffset();
});

$(document).on('change', '.waitlist-variants-container input', function(){
	var $val = $(this).data('value');
	if($val == 'refill' || $val == 'Refill') {
		$('a.refill-coming-soon-btn').show();
		$('a.join-waitlist-btn').hide();
	} else {
		$('a.refill-coming-soon-btn').hide();
		$('a.join-waitlist-btn').show();
	}
})

$(document).ready(function(){
	var checkInstances = setInterval(function(){
		if($('.instafeed-hover-layer').length > 0) {
			$('.instafeed-hover-layer').attr('aria-label', 'Play Video');
			clearInterval(checkInstances);
		}
	}, 500);
	var checkIframe = setInterval(function(){
		if($('#ps__widget_container').length) {
			$('#ps__widget_container iframe').attr('aria-modal', "true").attr('role', 'dialog');
			clearInterval(checkIframe);
		}
	}, 500);
});

// robust: set --app-height to the real visual viewport height in px
function setAppHeight() {
	const vh = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
	document.documentElement.style.setProperty('--app-height', `${Math.floor(vh)}px`);
}

// init
setAppHeight();

// listen to both window and visualViewport events for best coverage
window.addEventListener('resize', setAppHeight);
window.addEventListener('orientationchange', setAppHeight);
if (window.visualViewport) {
	window.visualViewport.addEventListener('resize', setAppHeight);
	window.visualViewport.addEventListener('scroll', setAppHeight); // handles some UI shifts
}